export enum RoutesEnum {
  ROOT = "/",
  HOME = "/home",
  LINKS = "/links",
  LOGIN = "/login",
  USERS = "/users",
  FEEDBACK = "/feedback",
  UPDATES = "/updates",
  COMPANIES = "/companies",
  FOLDERS = "/companies/folders",
  DATA_FOLDERS = "/companies/folders/data",
  RESTORE_PASSWORD_REQUEST = "/restore",
  RESTORE_PASSWORD_FORM = "/restore-password/:token",
}
